export const convertDataToApi = (data) => ({
  preview: data.preview || null,
  name: data.name,
  language: data.language ? data.language.value : null,
});
